export default "__VITE_ASSET__9x67Tn9C__"